import * as Yup from 'yup'

export const uploadBannerSchema = ({}) =>
  Yup.object().shape({
    thumbnail: Yup.mixed()
      .required('Banner Required')
      .test(
        'fileDimensions',
        'Banner must be exactly 320×100 pixels',
        (file) => {
          if (!file) return false;

          // If it's already a URL/string, skip validation (assume valid)
          if (typeof file === 'string') return true;

          // Otherwise, validate dimensions for uploaded File objects
          return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
              const isValid = img.width === 320 && img.height === 100;
              resolve(isValid);
            };
            img.onerror = () => resolve(false);
          });
        }
      ),
    name: Yup.string().required('Name Required'),
  });



const imageWidthAndHeight = (provideFile) => {
  // take the given file (which should be an image) and return the width and height
  const imgDimensions = { width: null, height: null }

  return new Promise(resolve => {
    const reader = new FileReader()

    reader.readAsDataURL(provideFile)
    reader.onload = function () {
      const img = new Image()
      img.src = reader.result

      img.onload = function () {
        imgDimensions.width = img.width
        imgDimensions.height = img.height

        resolve(imgDimensions)
      }
    }
  })
}

const imageDimensionCheck = Yup.addMethod(Yup.mixed, 'imageDimensionCheck', function (message, minRequiredWidth, minRequiredHeight, maxRequiredWidth, maxRequiredHeight) {
  return this.test('image-width-height-check', message, async function (value) {
    const { path, createError } = this

    if (!value) {
      return
    }

    const imgDimensions = await imageWidthAndHeight(value)

    if (imgDimensions.width < minRequiredWidth || imgDimensions.width > maxRequiredWidth) {
      return createError({
        path,
        message: `The image width needs to be betweeen ${minRequiredWidth}px - ${maxRequiredWidth}px!`
      })
    }

    if (imgDimensions.height < minRequiredHeight || imgDimensions.height > maxRequiredHeight) {
      return createError({
        path,
        message: `The image height needs to be between ${minRequiredHeight}px - ${maxRequiredHeight}px!`
      })
    }

    return true
  })
})
